import * as React from "react";
const SelectIcon = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 1.75h6c2.658 0 4.435.57 5.558 1.692C21.68 4.565 22.25 6.342 22.25 9v6c0 2.658-.57 4.435-1.692 5.558-1.123 1.122-2.9 1.692-5.558 1.692H9c-2.658 0-4.435-.57-5.558-1.692C2.32 19.435 1.75 17.658 1.75 15V9c0-2.658.57-4.435 1.692-5.558C4.565 2.32 6.342 1.75 9 1.75Zm0 .5c-2.34 0-4.075.411-5.207 1.543S2.25 6.66 2.25 9v6c0 2.34.411 4.075 1.543 5.207S6.66 21.75 9 21.75h6c2.34 0 4.075-.411 5.207-1.543S21.75 17.34 21.75 15V9c0-2.34-.411-4.075-1.543-5.207S17.34 2.25 15 2.25z"
            fill="#465050"
            stroke="#465050"
        />
        <path
            d="M12 14.91c-.19 0-.38-.07-.53-.22l-3.53-3.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3 3 3-3c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-3.53 3.53c-.15.15-.34.22-.53.22"
            fill="#465050"
        />
    </svg>
);
export default SelectIcon;
